import React from 'react';

export const CallbackNotification = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <rect width="28" height="28" fill="#FFFAE8" rx="14" />
      <mask
        id="a"
        width="16"
        height="16"
        x="6"
        y="6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
      >
        <path fill="#D9D9D9" d="M6 6h15.56v15.56H6z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#C8A311"
          d="M18.9341 19.6153c-1.3939 0-2.7526-.3108-4.0761-.9323-1.3239-.6211-2.4963-1.4423-3.5172-2.4637-1.0213-1.0209-1.84257-2.1933-2.46367-3.5172-.62154-1.3234-.93231-2.6821-.93231-4.07604 0-.1945.06484-.35658.1945-.48625.12967-.12966.29175-.1945.48625-.1945h2.62573c.1513 0 .2864.04863.4052.14588.1189.09725.1891.22151.2107.37279l.4215 2.26912c.0216.1513.019.289-.0078.413-.0273.1245-.0895.2354-.1867.3326l-1.556 1.5884c.4538.778 1.0211 1.5074 1.7018 2.1882.6808.6807 1.4318 1.2696 2.253 1.7667l1.5236-1.5236c.0972-.0973.2243-.1703.3812-.2191.1565-.0484.3103-.0618.4616-.0402l2.2368.4538c.1512.0324.2755.1052.3727.2185.0973.1137.1459.2461.1459.3974v2.6258c0 .1945-.0648.3565-.1945.4862-.1296.1297-.2917.1945-.4862.1945Z"
        />
      </g>
    </svg>
  );
};

export default CallbackNotification;
